import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EventModel } from '@app/events/shared/event.model';
import { provideFlatpickrDefaults } from 'angularx-flatpickr';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PaymentModel } from '@app/events/shared/payment.model';
import { ButtonComponent } from '@app/partials/form/button/button.component';
import { SelectComponent } from '@app/partials/form/select/select.component';
import { TextInputComponent } from '@app/partials/form/text-input/text-input.component';
import { PaymentService } from '@app/events/shared/payment.service';
import { TextareaComponent } from '@app/partials/form/textarea/textarea.component';
import { DatePickerComponent } from '@app/partials/form/date-picker/date-picker.component';
import { CheckboxComponent } from '@app/partials/form/checkbox/checkbox.component';

@Component({
  selector: 'app-event-payment-form',
  templateUrl: './payment-form.component.html',
  styleUrls: [],
  providers: [provideFlatpickrDefaults()],
  imports: [ButtonComponent, SelectComponent, TextInputComponent, TextareaComponent, DatePickerComponent, CheckboxComponent],
  standalone: true,
})
export class PaymentFormComponent {
  @Input() public event!: EventModel;

  @Output() paymentCreated = new EventEmitter<PaymentModel>();

  protected categoryChoices = [
    { value: 'Food', label: 'Food' },
    { value: 'Drinks', label: 'Drinks' },
    { value: 'Accommodation', label: 'Accommodation' },
    { value: 'Add-on', label: 'Add-on' },
    { value: 'Supplier', label: 'Supplier' },
    { value: 'Expense', label: 'Expense' },
    { value: 'Service', label: 'Service' },
    { value: 'Payment', label: 'Payment' },
  ];

  protected form: FormGroup<{
    amount: FormControl<string | null>;
    category: FormControl<string | null>;
    description: FormControl<string | null>;
    date_due: FormControl<string | null>;
    date_paid: FormControl<string | null>;
    amount_paid: FormControl<string | null>;
    is_reservation_fee: FormControl<boolean | null>;
  }>;

  constructor(private paymentService: PaymentService) {
    this.form = new FormGroup({
      amount: new FormControl('', [Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
      category: new FormControl('', [
        Validators.required,
        Validators.pattern(/^(Food|Drinks|Accommodation|Add-on|Supplier|Expense|Service|Payment)$/),
      ]),
      description: new FormControl('', [Validators.maxLength(1000)]),
      date_due: new FormControl(''),
      date_paid: new FormControl(''),
      amount_paid: new FormControl('0', [Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
      is_reservation_fee: new FormControl(false),
    });
  }

  save() {
    if (!this.form) {
      return;
    }
    if (this.form.invalid) {
      return;
    }

    const data = {
      amount: this.form.value.amount ?? null,
      description: this.form.value.description ?? null,
      category: this.form.value.category ?? null,
      event_id: this.event.id,
      date_due: this.form.value.date_due ?? null,
      date_paid: this.form.value.date_paid ?? null,
      amount_paid: this.form.value.amount_paid ? parseFloat(this.form.value.amount_paid) : 0,
      is_reservation_fee: this.form.value.is_reservation_fee ?? false,
    };

    this.paymentService.save(data as unknown as PaymentModel).subscribe({
      next: (response) => {
        this.paymentCreated.emit(response.data);
      },
      error: (error) => {
        console.error('Error creating payment:', error);
      },
    });

    this.form.reset();
    this.form.markAsPristine();
  }
}
